// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"SvgSection_svgWrapper__MmK-0","SVGImagesWrapper":"SvgSection_SVGImagesWrapper__39TR4","VirtualRamWrapper":"SvgSection_VirtualRamWrapper__3xWIU"};